import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatDatePipe } from '../../../shared/pipes/chat-date.pipe';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../forms/button/button.component';
import { DividerComponent } from '../../common/divider/divider.component';

@Component({
  selector: 'app-research-card',
  imports: [ChatDatePipe, CommonModule, ButtonComponent, DividerComponent],
  templateUrl: './research-card.component.html',
  styleUrl: './research-card.component.css'
})
export class ResearchCardComponent {
  @Input() request:any;
  @Output() fulfill = new EventEmitter<any>();

  defaultAvatar = 'assets/img/default_avatar_1.png';

  handleFulfill(event: Event){
    event.stopPropagation();
    event.preventDefault();
    this.fulfill.emit(this.request);
  }
}
